import React from "react";
import AdminLayout from "../../components/layouts/AdminLayout";
import { Users, CreditCard, AlertCircle } from "lucide-react";

const AdminCustomers = () => {
  const customers = [
    { name: "Mary Wambui", status: "Active", tier: "Gold" },
    { name: "Kamau Holdings", status: "Pending", tier: "Silver" },
    { name: "Joy Kirwa", status: "Suspended", tier: "Basic" },
  ];

  return (
    <AdminLayout>
      <div className="space-y-6">
        <header className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-amber-50 text-amber-700 flex items-center justify-center border border-amber-100">
            <Users className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-slate-900">Customers</h1>
            <p className="text-sm text-slate-600">
              Oversee customer onboarding, billing, and support escalations.
            </p>
          </div>
        </header>

        <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-hidden">
          <table className="min-w-full divide-y divide-slate-100">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Customer</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Tier</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Status</th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-600">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {customers.map((customer) => (
                <tr key={customer.name}>
                  <td className="px-4 py-3 text-sm text-slate-800">{customer.name}</td>
                  <td className="px-4 py-3 text-sm text-slate-700">{customer.tier}</td>
                  <td className="px-4 py-3">
                    <span
                      className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                        customer.status === "Active"
                          ? "bg-emerald-50 text-emerald-700"
                          : customer.status === "Pending"
                          ? "bg-amber-50 text-amber-700"
                          : "bg-rose-50 text-rose-700"
                      }`}
                    >
                      {customer.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-slate-700 flex items-center gap-2">
                    <button className="px-2 py-1 text-xs font-semibold text-blue-700 hover:underline">
                      View
                    </button>
                    <button className="px-2 py-1 text-xs font-semibold text-emerald-700 hover:underline">
                      Approve
                    </button>
                    <button className="px-2 py-1 text-xs font-semibold text-rose-700 hover:underline">
                      Suspend
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <div className="bg-white border border-slate-100 rounded-xl p-4 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <CreditCard className="h-5 w-5 text-blue-600" />
              <p className="text-sm font-semibold text-slate-900">Billing oversight</p>
            </div>
            <p className="text-sm text-slate-600">
              View invoices, payments, and refunds. Integrate with your billing provider to make this
              section live.
            </p>
          </div>

          <div className="bg-white border border-slate-100 rounded-xl p-4 shadow-sm">
            <div className="flex items-center gap-3 mb-2">
              <AlertCircle className="h-5 w-5 text-amber-600" />
              <p className="text-sm font-semibold text-slate-900">Escalations</p>
            </div>
            <p className="text-sm text-slate-600">
              Track high-priority issues from customers and assign them to company admins or employees.
            </p>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminCustomers;
